import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        flex: 1,
        minWidth: 200,
        sortable: false,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'name',
        headerName: 'Tên loại hành vi',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
